// require("intersection-observer");
// IntersectionObserver.prototype.POLL_INTERVAL = 100; // Time in milliseconds.

import barba from '@barba/core';
import { phoneMask } from "@l/input-mask";
import { ZayavkaO } from "./zayavka-open";
export default function intersectionObserver() {
  loopBlog();
  LazyVideo();
  function LazyVideo() {
    var item = new IntersectionObserver(function (entries, imgObserver) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.classList.contains('loaded')) {
          var speed = entry.target.getAttribute('data-speed') !== null ? entry.target.getAttribute('data-speed') : "1";
          var controls = entry.target.getAttribute('data-controls') !== null ? "controls" : "";
          entry.target.classList.add('loaded');
          var video = entry.target;
          var url = video.getAttribute('data-lazy-video');
          var img = video.getAttribute("data-img") || "";
          video.innerHTML += "\n          <video preload=\"auto\" ".concat(controls, " playsinline=\"\" poster=\"").concat(img, "\" muted autoplay=\"true\" type=\"video/mp4\" crossorigin=\"anonymous\" loop >\n          <source src=\"").concat(url, "\">\n          </video>");
          video.querySelector('video').playbackRate = speed;
        }
      });
    });
    $$("[data-lazy-video]").forEach(function (e) {
      return item.observe(e);
    });
  }
  function loopBlog() {
    var item = new IntersectionObserver(function (entries, imgObserver) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          el.classList.add('loaded');
          var url = $(".next__page__url");
          var loadItem = document.createElement("div");
          el.innerHTML = "<div class=\"preloader-ring\"></div>";
          axios.post(url.href).then(function (r) {
            loadItem.innerHTML = r.data;
            var newUrl = loadItem.querySelector(".next__page__url").href;
            $('.blog__stat__main').appendChild(loadItem.querySelector(".blog__stat"));
            url.href = newUrl;

            // setTimeout(() => barba.go(newUrl), 100);

            // window.history.pushState(null, null, url.href)

            // $$('.blog__stat')[0].remove()

            // setTimeout(() => {
            //   window.scrollTo({top: 0});
            // }, 100);

            var last = $$('.blog__stat')[$$('.blog__stat').length - 1];
            ZayavkaO();
            phoneMask();

            // console.log(last);
            var tl = gsap.timeline();
            tl.fromTo(last, {
              duration: .5,
              opacity: 0,
              y: "250"
            }, {
              opacity: 1,
              y: 0,
              ease: "power3.out",
              onComplete: function onComplete() {
                // $$('.blog__stat')[0].remove()
                // window.scrollTo({top: 0});
              }
            });
          });
        }
      });
    });
    $$(".next__page__hook").forEach(function (e) {
      return item.observe(e);
    });
  }
}